import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CanvasToggleButton } from '@mygpt/app/chat/components/Canvas/ToggleButton';
import { ratingType } from '@mygpt/types';
import { ChatContentBottomButtonsProps } from '../ChatContentBottomButton';
import { DislikeButton, LikeButton } from '@mygpt/app/chat/components/FeedbackButton';
import { TTSButton } from '@mygpt/app/chat/components/ChatContentBottomButton/TTSButton';
import { CopyButton } from '@mygpt/app/chat/components/ChatContentBottomButton/CopyButton';
import { TransferToHumanButton } from '@mygpt/app/chat/components/ChatContentBottomButton/TransferToHumanButton';
import { useMemo } from 'react';
import { useBot } from '@mygpt/app/bot';

export const DesktopView = ({
  item,
  id,
  sessionId,
  pageSource,
  enableTTS,
  isPlaying,
  ttsLoading,
  onTTSPlayOrPause,
  copied,
  setCopied,
  floatingActions,
}: ChatContentBottomButtonsProps) => {
  const { t } = useTranslation();
  const { robotInfo } = useBot();

  const configs = useMemo(() => {
    return robotInfo?.configs;
  }, [robotInfo]);

  const showTransferToHuman =
    item.llm_can_answer === false &&
    pageSource !== 'playground' &&
    !!configs?.transfer_to_human?.sta &&
    !!configs?.transfer_to_human?.url;

  // 桌面端布局（保持原样）
  return (
    <div className={`${floatingActions && 'xl:absolute xl:right-0 xl:top-0 xl:translate-x-full xl:pl-2 pt-1'} mt-1`}>
      <Group justify="space-between">
        <Group gap={5} wrap="nowrap">
          <TTSButton
            text={item.text}
            isPlaying={isPlaying}
            ttsLoading={ttsLoading}
            onTTSPlayOrPause={onTTSPlayOrPause}
            enableTTS={enableTTS}
          />

          <LikeButton
            aiId={id}
            sessionId={sessionId}
            messageId={item.messageId || ''}
            rating={item.rating as ratingType}
          />
          <DislikeButton
            aiId={id}
            sessionId={sessionId}
            messageId={item.messageId || ''}
            rating={item.rating as ratingType}
          />

          <CopyButton text={item.text} copied={copied} setCopied={setCopied} />

          {showTransferToHuman && (
            <TransferToHumanButton messageId={item.messageId || ''} sessionId={sessionId} pageSource={pageSource} />
          )}
        </Group>

        <CanvasToggleButton
          messageId={item.messageId || ''}
          canvas_url={item.canvas_url || ''}
          canvas_title={item.canvas_title || ''}
        />
      </Group>
    </div>
  );
};
